module.exports = __webpack_public_path__ + "static/media/duplicateShiftHere.3808564f.svg";